import PropTypes from "prop-types"
import React, { useState } from "react"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"

import Card from "@knowit-alma/common/src/components/molecules/Card/Card"
import CarouselArrow from "@knowit-alma/common/src/components/molecules/CarouselArrow/CarouselArrow"

import styles from "./Carousel.module.scss"

const ModifiedCarousel = ({
  slides,
  heading,
  columns = 2,
  fadeOutside = false,
}) => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 1000000, min: 992 },
      items: columns,
      slidesToSlide: 1,
      partialVisibilityGutter: 0,
    },
    tablet: {
      breakpoint: { max: 991, min: 768 },
      items: 2,
      slidesToSlide: 1,
      partialVisibilityGutter: 0,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 30,
    },
  }

  const [slidingInProgress, setSlidingInProgress] = useState(false)

  return slides ? (
    <section
      className={`${styles.element} ${
        fadeOutside ? styles.fadeOutside : ""
      } make-full-width-on-mobile`}
    >
      {heading && (
        <div className="base-margin-bottom-small text-align-left">
          <h2>{heading}</h2>
        </div>
      )}
      <Carousel
        infinite={false}
        ssr={true}
        swipeable={true}
        partialVisible={true}
        containerClass={`${styles.carousel} ${
          slidingInProgress ? styles.slidingInProgress : ""
        }`}
        responsive={responsive}
        keyBoardControl
        arrows={true}
        minimumTouchDrag={30}
        customLeftArrow={
          <CarouselArrow
            position="left"
            customClass={`${styles.arrow} ${
              columns === 3 ? styles.columns3 : styles.columns2
            } ${styles.arrowLeft}`}
          />
        }
        customRightArrow={
          <CarouselArrow
            position="right"
            customClass={`${styles.arrow} ${
              columns === 3 ? styles.columns3 : styles.columns2
            } ${styles.arrowRight}`}
          />
        }
        beforeChange={(nextSlide, { currentSlide, onMove }) => {
          setSlidingInProgress(true)
        }}
        afterChange={(previousSlide, { currentSlide, onMove }) => {
          setSlidingInProgress(false)
        }}
      >
        {slides.map((slide, index) => {
          return (
            <div key={index} className={styles.item}>
              <Card
                headingSize={heading ? "h3" : "h2"}
                image={slide.image}
                imageAspectRatio={"3:2"}
                tagline={slide.tagline}
                title={slide.title}
                url={slide.url}
                cta={slide.cta}
                internalLink={true}
              />
            </div>
          )
        })}
      </Carousel>
    </section>
  ) : (
    ""
  )
}

ModifiedCarousel.propTypes = {
  cards: PropTypes.array,
}

export default ModifiedCarousel
